import * as yup from "yup";

export const editPurchasedElectricityValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  year: yup.string().required("Year is required"),
  month: yup.string().required("Month is required"),
  unit: yup.string().required("Unit is required"),
  calculationApproach: yup
    .string()
    .required("Calculation approach is required"),
  amount: yup
    .number()
    .typeError("Amount of fuel must be a valid number")
    .required("Amount of fuel is required"),
});
